const initialState = {
    loading: false,
    error: null,
    message:null,
    newsletterList:null,
    articleList:null,
    newsletter:null,
    postNewsletter:null,
    postNewsletterError:null,
    newsletterArticleList:null,
    postNewsletterArticleList:null,
    postNewsletterArticleListError:null,
    articleListLoading:null,
    contentCampaignList:null
}

const NewsletterReducer = (state = initialState, action) => {
    switch(action.type){
        case 'GET_CMS_NEWSLETTER_LIST_REQUEST':
            return {
                ...state,
                loading:true,
            }    
        case 'GET_CMS_NEWSLETTER_LIST_SUCCESS':
            return {
                ...state,
                loading:false,
                newsletterList:action.payload,
            }
        case 'GET_CMS_NEWSLETTER_LIST_FAILURE':
            return {
                ...state,
                loading:false,
                error:action.payload,
            }            
        case 'CLEAR_CMS_NEWSLETTER_LIST':
            return{
                ...state,
                newsletterList:null
            }
        case 'ADD_CMS_NEWSLETTER_LIST_SUCCESS':
            return{
                ...state,
                newsletterList:[...state.newsletterList,...action.payload],
                error:false
            }
        case 'GET_ARTICLE_LIST_REQUEST':
            return{
                ...state,
                loading:true
            }
        case 'GET_ARTICLE_LIST_SUCCESS':
            return{
                ...state,
                loading:false,
                articleList:action.payload

            }
        case 'GET_ARTICLE_LIST_FAILURE':
            return{
                ...state,
                loading:false,
                error:action.payload
            }
        case 'CLEAR_ARTICLE_LIST':
            return{
                ...state,
                articleList:null,
                error:null,
            }

        case 'GET_KEYWORD_LIST_SUCCESS':
            return{
                ...state,
                newsletterKeywordList:action.payload
            }
        case 'GET_KEYWORD_LIST_FAILURE':
            return{
                ...state,
                error:action.payload
            }
        case 'CLEAR_KEYWORD_LIST':
            return{
                ...state,
                newsletterKeywordList:null,
                error:null
            }

        case 'GET_CMS_NEWSLETTER_REQUEST':
            return{
                ...state,
                loading:true
            }    
        case 'GET_CMS_NEWSLETTER_SUCCESS':
            return{
                ...state,
                newsletter:action.payload,
                loading:false
            }
        case 'GET_CMS_NEWSLETTER_FAILURE':
            return{
                ...state,
                error:action.payload,
                loading:false
            }
        case 'CLEAR_NEWSLETTER_DETAIL':
            return{
                ...state,
                newsletter:null,
                error:null
            }    
        
        case 'POST_CMS_NEWSLETTER_SUCCESS':
            return{
                ...state,
                postNewsletter:action.payload
            }
        
        case 'POST_CMS_NEWSLETTER_FAILURE':
            return{
                ...state,
                postNewsletterError:action.payload
            }
        case 'CLEAR_POST_NEWSLETTER':
            return{
                ...state,
                postNewsletter:null,
                postNewsletterError:null,
            }
        case 'CLEAR_POST_NEWSLETTER_MESSAGE':
            return{
                ...state,
                postNewsletterError:null,
            }
        case 'GET_CMS_NEWSLETTER_ARTICLE_LIST_REQUEST':
            return{
                ...state,
                articleListLoading:true
            }
        case 'GET_CMS_NEWSLETTER_ARTICLE_LIST_SUCCESS':
            return{
                ...state,
                articleListLoading:false,
                newsletterArticleList:action.payload

            }
        case 'GET_CMS_NEWSLETTER_ARTICLE_LIST_FAILURE':
            return{
                ...state,
                articleListLoading:false,
                error:action.payload
            }

        case 'UPDATE_NEWSLETTER_ARTICLE_LIST':
            let updatedArticleList=state.newsletterArticleList
            updatedArticleList.results[action.index].campaign=action.payload
            return{
                ...state,
                newsletterArticleList:updatedArticleList
            }
        
        case 'UPDATE_NEWSLETTER_ARTICLE_LIST_CAMPAIGN_WEIGHT':
            let updatedArticleListCampaignWeight=state.newsletterArticleList
            updatedArticleListCampaignWeight.results[action.index].campaign_weight=action.payload
            return{
                ...state,
                newsletterArticleList:updatedArticleListCampaignWeight
            }   
        case 'CLEAR_NEWSLETTER_ARTICLE_LIST':
            return{
                ...state,
                newsletterArticleList:null,
                error:null
            }

        case 'POST_CMS_NEWSLETTER_ARTICLE_LIST_SUCCESS':
            
            return{
                ...state,
                loading:false,
                postNewsletterArticleList:action.payload

            }
        case 'POST_CMS_NEWSLETTER_ARTICLE_LIST_FAILURE':
            return{
                ...state,
                loading:false,
                postNewsletterArticleListError:action.payload
            }
            
        case 'GET_CMS_NEWSLETTER_CONTENT_CAMPAIGN_LIST_REQUEST':
            return{
                ...state,
                loading:true
            }
        case 'GET_CMS_NEWSLETTER_CONTENT_CAMPAIGN_LIST_SUCCESS':
           return{
               ...state,
               loading:false,
               contentCampaignList:action.payload
               }
        case 'GET_CMS_NEWSLETTER_CONTENT_CAMPAIGN_LIST_FAILURE':
            return{
                ...state,
                loading:false,
                contentCampaignList:action.payload
            }
            
         
        default: return state
    }
}

export default NewsletterReducer